import React from 'react'
import moment from 'moment'

function Copyright() {
    return (
        <div>
            <div className="copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="copy">
                                <p>{moment().format('Y')} | MVRS Staking</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Copyright
